import VueRouter from "vue-router";
import Vue from "vue";

Vue.use(VueRouter);
import Index from "../components/index.vue";
import Index2 from "../components/index2.vue";
import privacy from "../components/privacy.vue"
import terms from "../components/terms.vue"
import list from "../components/list.vue"
const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: "/",
      component: Index,
    },
    {
      path: "/Index2",
      component: Index2,
    },
    {
      path: '/detail1',
      beforeEnter() {
        window.location.href = '/detail1.html'; // 重定向到静态 HTML 文件
      }
    },{
      path:'/privacy',
      component:privacy
  }
  ,{
      path:'/terms',
      component:terms
  }
  ,{
    path:'/list',
    beforeEnter() {
      window.location.href = '/list.html'; // 重定向到静态 HTML 文件
    }
}
  ],
});

export default router;
